// Reopen Shopify's own consent dialog from the custom AYUME footer.
document.addEventListener('click', async (event) => {
  const link = event.target.closest?.('.av-footer a[href="#shopifyReshowConsentBanner"]');
  if (!link || !window.privacyBanner?.showPreferences) return;
  event.preventDefault();
  await window.privacyBanner.showPreferences();
});
